import apiClient from '../apiClient';
import { GET_CITY_LIST_URL } from '../apiUrl';

const getCityListApi = () => {
  return apiClient.get(GET_CITY_LIST_URL);
};

export default getCityListApi;
